import { useState, useRef, useEffect } from 'react'
import arrowRight from '../../../../assets/icons/arrowRight.svg'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '../../../../redux'
import ivyLeagueSlice from '../../../../redux/slice/ivyLeague.slice'
import { IvyLeagueFamilyInfo, Kid } from '../../../../types/ivyLeague'

export const Step1 = () => {
  const dispatch: AppDispatch = useDispatch()
  const childrenOptions = [1, 2, 3, 4, 5]
  const { familyInfo, kids } = useSelector((state: RootState) => state.ivyLeague)
  const [childrenDropdown, setChildrenDropdown] = useState(false)
  const dropdownRef = useRef<HTMLDivElement>(null)
  const dropdownContainerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!childrenDropdown || !dropdownContainerRef.current) return
    dropdownContainerRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
  }, [childrenDropdown])

  return (
    <div className="step1">
      <div className="row">
        <div className="inputFieldArea">
          <label className="fieldLabel">Your First Name</label>
          <input
            type="text"
            className="inputField"
            placeholder="John"
            value={familyInfo.firstName}
            onChange={(e) => {
              const updated: IvyLeagueFamilyInfo = { ...familyInfo, firstName: e.target.value }
              dispatch(ivyLeagueSlice.actions.setFamilyInfo(updated))
            }}
          />
        </div>
        <div className="inputFieldArea">
          <label className="fieldLabel">Your Last Name</label>
          <input
            type="text"
            className="inputField"
            placeholder="Doe"
            value={familyInfo.lastName}
            onChange={(e) => {
              const updated: IvyLeagueFamilyInfo = { ...familyInfo, lastName: e.target.value }
              dispatch(ivyLeagueSlice.actions.setFamilyInfo(updated))
            }}
          />
        </div>
      </div>
      <div className="row">
        <div className="inputFieldArea">
          <label className="fieldLabel">Your Email</label>
          <input
            type="email"
            className="inputField"
            placeholder="email@example.com"
            value={familyInfo.email}
            onChange={(e) => {
              const updated: IvyLeagueFamilyInfo = { ...familyInfo, email: e.target.value }
              dispatch(ivyLeagueSlice.actions.setFamilyInfo(updated))
            }}
          />
        </div>
        <div className="inputFieldArea">
          <label className="fieldLabel">Your Phone Number</label>
          <input
            type="text"
            className="inputField"
            placeholder="987 654 3210"
            value={familyInfo.phone}
            onChange={(e) => {
              const updated: IvyLeagueFamilyInfo = { ...familyInfo, phone: e.target.value }
              dispatch(ivyLeagueSlice.actions.setFamilyInfo(updated))
            }}
          />
        </div>
      </div>
      <div className="inputFieldArea" ref={dropdownRef}>
        <label className="fieldLabel">Select Number of Children</label>
        <div
          className="selectInputFieldArea"
          onClick={() => setChildrenDropdown(prev => !prev)}
        >
          {kids.length > 0 ? kids.length : 'Select...'}
          <img className="arrowIcon" src={arrowRight} alt="" />
        </div>
        {childrenDropdown && (
          <div className="dropdownContainer" ref={dropdownContainerRef}>
            {childrenOptions.map((num, index) => (
              <div
                className="dropdownOption"
                key={`${num}:${index}`}
                onClick={(e) => {
                  e.stopPropagation()
                  const kids: Kid[] = []
                  for (let i = 0; i < num; i++) {
                    const id = `Child ${i + 1}`
                    kids.push({
                      id,
                      grade: '',
                      programs: [],
                      transportMode: 'Parent',
                      usesExtendedHours: false,
                      finaleTrip: false
                    })
                  }
                  dispatch(ivyLeagueSlice.actions.setKids(kids))
                  setChildrenDropdown(false)
                }}
              >
                {num}
              </div>
            ))}
          </div>
        )}
      </div>
      {childrenDropdown && (
        <div className="backDrop" onClick={() => setChildrenDropdown(false)} />
      )}
    </div>
  )
}
